import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { StyledLinearLineDivider, StyledLineDivider } from './LineDivider.styles.js';

const LineDivider = forwardRef((props, ref) => {
    return props.linearGradient ? (jsx(StyledLinearLineDivider, Object.assign({}, props))) : (jsx(StyledLineDivider, Object.assign({}, props)));
});

export { LineDivider as default };
//# sourceMappingURL=LineDivider.js.map
